module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/discount-icon-a1e6f59cee7bace7cd69a7286cf80534.png";